import { useState } from 'react';
import './section-lib.less';
import { ContextMenuFC } from 'tncet-common';
import TnModal from '@/commons/widget/base-modal';
import { Image, Input, Modal, message } from 'antd';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import { PSection } from '@/commons/interface/speccommon/section';
import { deleteProjectSection, updateSection } from '@/api/spec-common/section';
import { getSectionTypeItemInfo } from '@/commons/enums/speccommon/section';

import { ReactComponent as CheckSvg } from '@/commons/icons/side-bar/side-check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/side-bar/side-checked.svg';
import { ReactComponent as JoinSvg } from '@/commons/icons/side-bar/side-join.svg';

interface IProps {
    sections: PSection[]
    width: number
    setSections: (arr: PSection[]) => void
    viewSectionDetail: (id: string, mode: 'detail' | 'modify') => void
    deleting: boolean
    selectedSections: PSection[]
    setSelectedSections: (value: PSection[]) => void
}

export default function SectionLib(props: IProps) {

    const { projectUuid } = useParams();
    const [cmOpen, setCmOpen] = useState<boolean>(false);
    // const [top, setTop] = useState<number>();
    // const [left, setLeft] = useState<number>();
    const [selectedItem, setSelectedItem] = useState<PSection>(null);
    const [editId, setEditId] = useState<string>('');
    const [editName, setEditName] = useState<string>('');


    // const onRightClick = (e, line) => {
    //     e.preventDefault();
    //     let clientX = e.clientX;
    //     let clientY = e.clientY;
    //     setLeft(clientX);
    //     setTop(clientY);
    //     e.preventDefault();
    //     setCmOpen(true);
    //     setSelectedItem(line);
    // }

    const onDelete = (selected) => {
        setCmOpen(false);
        TnModal().deleteModal({
            closable: false,
            onOk() {
                deleteProjectSection(projectUuid, selected?.id).then(res => {
                    message.success("删除成功");
                    props.setSections([...props?.sections]?.filter(item => item.id !== selected?.id));
                }).finally(() => {
                    Modal.destroyAll();
                    setSelectedItem(null);
                })
            },
            onCancel() {
                Modal.destroyAll();
                setSelectedItem(null);
            },
        })
    }

    const checkClick = (ps: PSection) => {
        let newArr = [...props.selectedSections] || [];
        let idx = newArr?.findIndex(item => item.id === ps.id);
        if (idx > -1) {
            newArr.splice(idx, 1);
        } else {
            newArr.push(ps);
        }
        props.setSelectedSections(newArr);
    }

    const inputBlur = (ps: PSection) => {
        if (editName == null || editName === '') {
            message.error("名称不能为空");
            setEditId('');
            setEditName('');
            return;
        }
        let newArr = [...props.sections];
        let idx = newArr?.findIndex(item => item.id === ps.id);
        if (props.sections[idx].name == editName) {
            setEditId('');
            setEditName('');
            return;
        }
        let newObj = { ...newArr[idx] };
        newObj.name = editName;
        newArr[idx] = newObj;
        props.setSections(newArr);

        updateSection(newObj.id, newObj).then(res => {
            if (res.status === 200) {
                message.success("编辑成功");
            }
        }).catch(err => {
            message.error("编辑失败");
        }).finally(() => {
            setEditId('');
            setEditName('');
        })
    }

    const handleDoubleClick = (section) => {
        setEditId(section.id);
        setEditName(section?.name || '');
    };


    return (
        <div className='section-lib-container'>
            {props?.sections?.map(item => (
                <div
                    key={item.id}
                    className={classnames({
                        "item": true,
                        "item-active": selectedItem?.id == item?.id
                    })}
                    // onContextMenu={(e) => onRightClick(e, item)}
                    style={{ width: props.width - 32 }}
                >
                    {props.deleting && !props.selectedSections?.some(sf => sf.id === item.id) && <CheckSvg
                        className='check-icon'
                        onClick={() => checkClick(item)}
                    />}
                    {props.deleting && props.selectedSections?.some(sf => sf.id === item.id) && <CheckedSvg
                        className='check-icon'
                        onClick={() => checkClick(item)}
                    />}
                    <div className='content' onDoubleClick={() => handleDoubleClick(item)}>
                        <Image width={16} height={16} preview={false} src={getSectionTypeItemInfo(item.type)?.thumbnail} className='img' />
                        {editId !== item.id && <div className="text">{item.name}</div>}
                        {editId === item.id && <Input
                            value={editName}
                            style={{ height: 22, marginLeft: 8, marginRight: 8 }}
                            onChange={(e) => setEditName(e.target.value)}
                            onBlur={() => inputBlur(item)}
                            autoFocus
                        />}
                        {/* {<div className='text'>{item.name}</div>} */}
                        <JoinSvg className='join-icon' onClick={() => {
                            props.viewSectionDetail(item?.id, 'modify');
                            props.setSelectedSections([]);
                        }} />
                    </div>
                </div>
            ))}

            <ContextMenuFC
                visible={cmOpen}
                top={0}
                left={0}
                width={104}
                wrapperClassname='tn-right-context-menu'
                onCancel={() => { setCmOpen(false); setSelectedItem(null); }}
            >
                <div className='item' onClick={() => onDelete(selectedItem)}>删除</div>
                {selectedItem?.isSelfDefine && <div className='item' onClick={() => props.viewSectionDetail(selectedItem?.id, 'modify')}>编辑信息</div>}
                <div className='item' onClick={() => props.viewSectionDetail(selectedItem?.id, 'detail')}>查看详情</div>
            </ContextMenuFC>
        </div>
    )
}